// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ng-valid[required], .ng-valid.required  {
    border: 1px solid #3c763d; 
  }
  .ng-touched.ng-invalid:not(form)  {
    border:1px solid #a94442; 
  }
  .report-tab-content .form-group {
    padding-bottom: 25px;
    margin-bottom: 0px;
  }
  .text-danger{
    position: absolute;
    width: 94%;
  }
  .text-center{
    text-align: center !important;
  }
  #mySetting .modal-body{
    max-height: 350px;
    overflow-y: scroll;
  }
  .color-pink{
  color:#FFC0CB !important;
}
  .numberCircle { 
  
  border-radius:50%;
  width:20px;
  height:20px;
  display:block;
  float:center;
  border:2px solid #000000;
  color:#000000;
  text-align:center;
  margin-right:5px;
  }
  .btn-2{
    background: #00a6c6 !important;
  }
  .color-2{
    color:#00a6c6;
  }
  .status-block{
    margin-top: 30px;
  }
  .status-block .status-text{
    top: 5px;
    position: relative;
    float: left;
  }
  .status-bar{padding: 18px 0}
  .title-form .form-group {
  
  }
  .report-action-btn span{
    background: #00a6c6;
    padding: 3px 0 0 5px;
    color: #fff;
    border-radius: 50%;
    height: 25px;
    font-size: 12px;
    width: 25px;
    cursor: pointer;
  }
  
  .sn_dec {width: 80%}
  .glyphicon-pencil{margin: 0 7px;}
  .pagination>li>a, .pagination>li>span { border-radius: 50% !important;margin: 0 5px;}
  .pagination{margin: 0px}
  .btn-sm-rounded{    vertical-align: top;
    margin-top: 6px;}
    .modal-body {
      position: relative;
      padding: 28px 46px;
  }
  .plan-a{float: left;width: 100%;}
  .clr_bg{background: #fff;}
  table tr td:last-child{text-align: right;}
  .btn-gray {
    background-color: #999!important;
}
.planhead{float: left}
.planhead1{float: right}
.client-name {
  
    color: #d6104c;
    font-weight: bold;       width: 135px;
    float: right
}
.client-name span {
    float: left;
    font-size: 13px;
    width: 100%;
    font-weight: normal;
    color: #949599;
}
.bluecomplete{color: #00a6c6}
.tab-content{height: auto;
 }
  .rdesc{padding-top: 0;margin-top: -2px}
  .btn-circle {
    width: 30px;
    height: 30px;
    text-align: center;
    padding: 6px 0;
    font-size: 12px;
    line-height: 1.428571429;
    border-radius: 15px;
}

.btn-primary {
  border-color: #949599;
  position: relative;
  top: 42px;
  left: -11px;    background-color: #fff;
}
.glyphicon {

  color: #949599;
}
.scenario .tab-content {
  height: auto;
  overflow: hidden;}
  .btn-primary{position: inherit}

  #scenario-list-accordion .report-arrow {
    cursor: pointer;
    padding: 6px;
    border: 2px solid #00a6c6;
    border-radius: 50%;
    color: #00a6c6;
    width: 30px;
    height: 30px;
}


.panel-title {
  font-size: 16px;
  color: inherit;
  display: inline;
  background: #0075bc !important;
  padding: 4px 21px;
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
  padding-left: 34px;
}
.panel-title > a:before {
    float: left !important;
    font-family: FontAwesome;
    content:"\\f068";
    padding-right: 5px;
    color: #fff;
    position: relative;
    left: 30px;
}
.panel-title > a.collapsed:before {
    float: left !important;
    content:"\\f067";
    color: #fff;
    position: relative;
    left: 30px;
}
.panel-title > a:hover, 
.panel-title > a:active, 
.panel-title > a:focus  {
    text-decoration:none;
}
.panel-body {
  padding: 15px 40px;
}
.left-block{float: left}
.right-block{float: right}
.panel{border:none;}
.accord-block{float: left;width: 100%;    margin-bottom: 15px;}
.accord-block:last-child{    margin-bottom: 0;}
.panel-group {
 
  background: #fff;
}
.rdesc{padding-top: 0;margin-top: -2px}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}

.bus-name .btn-primary {
border-color: #949599;
position: relative;
top: 42px;
left: -11px;    background-color: #fff;
}
.bg-white .glyphicon {

color: #949599;
}
.client-name {
  color: #d6104c;
  font-weight: bold;
  width: 135px;
  float: right;
}
.client-name span {
  float: left;
  font-size: 13px;
  width: 100%;
  font-weight: normal;
  color: #949599;
}
.btn-gray {
  background-color: #999!important;
}
.edit1{top:7px;}
.btn-marign{margin-bottom: 10px}
#accordion_new b{    color: #00a6c6;}
#accordion_new  .row{    margin-bottom: 7px;}

.panel-body td th ,.panel-body tr td,.panel-body tr th {
  border: 1px solid #ccc;
  padding: 6px 0;
  text-align: center !important;
}
.navbar-nav>li>a{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  font-size: 13px;
  margin-left: -7px;
}
.nav>li>a>img {
  max-width: none;
  width: 32px;
  margin-right: 0px;
  margin-bottom: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/app/view-report/view-report.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;EACA,wBAAwB;AAC1B;EACE;;EAEA,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,kBAAkB;IAClB,WAAW;EACb;EACA,YAAY,eAAe;EAC3B;;EAEA;EACA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA,SAAS,UAAU;EACnB,kBAAkB,aAAa,CAAC;EAChC,wCAAwC,6BAA6B,CAAC,aAAa,CAAC;EACpF,YAAY,WAAW;EACvB,oBAAoB,mBAAmB;IACrC,eAAe,CAAC;IAChB;MACE,kBAAkB;MAClB,kBAAkB;EACtB;EACA,QAAQ,WAAW,CAAC,WAAW,CAAC;EAChC,QAAQ,gBAAgB,CAAC;EACzB,uBAAuB,iBAAiB,CAAC;EACzC;IACE,gCAAgC;AACpC;AACA,UAAU,WAAW;AACrB,WAAW,YAAY;AACvB;;IAEI,cAAc;IACd,iBAAiB,QAAQ,YAAY;IACrC;AACJ;AACA;IACI,WAAW;IACX,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;AACA,cAAc,cAAc;AAC5B,aAAa,YAAY;CACxB;EACC,OAAO,cAAc,CAAC,gBAAgB;EACtC;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW,KAAK,sBAAsB;AACxC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB,CAAC;EACjB,aAAa,iBAAiB;;EAE9B;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;;;IAGI,oBAAoB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA,YAAY,WAAW;AACvB,aAAa,YAAY;AACzB,OAAO,WAAW,CAAC;AACnB,cAAc,WAAW,CAAC,WAAW,KAAK,mBAAmB,CAAC;AAC9D,6BAA6B,gBAAgB,CAAC;AAC9C;;EAEE,gBAAgB;AAClB;AACA,OAAO,cAAc,CAAC,gBAAgB;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;AACA,qBAAqB;AACrB,kBAAkB;AAClB,SAAS;AACT,WAAW,KAAK,sBAAsB;AACtC;AACA;;AAEA,cAAc;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA,OAAO,OAAO,CAAC;AACf,YAAY,mBAAmB;AAC/B,qBAAqB,cAAc,CAAC;AACpC,yBAAyB,kBAAkB,CAAC;;AAE5C;EACE,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".ng-valid[required], .ng-valid.required  {\r\n    border: 1px solid #3c763d; \r\n  }\r\n  .ng-touched.ng-invalid:not(form)  {\r\n    border:1px solid #a94442; \r\n  }\r\n  .report-tab-content .form-group {\r\n    padding-bottom: 25px;\r\n    margin-bottom: 0px;\r\n  }\r\n  .text-danger{\r\n    position: absolute;\r\n    width: 94%;\r\n  }\r\n  .text-center{\r\n    text-align: center !important;\r\n  }\r\n  #mySetting .modal-body{\r\n    max-height: 350px;\r\n    overflow-y: scroll;\r\n  }\r\n  .color-pink{\r\n  color:#FFC0CB !important;\r\n}\r\n  .numberCircle { \r\n  \r\n  border-radius:50%;\r\n  width:20px;\r\n  height:20px;\r\n  display:block;\r\n  float:center;\r\n  border:2px solid #000000;\r\n  color:#000000;\r\n  text-align:center;\r\n  margin-right:5px;\r\n  }\r\n  .btn-2{\r\n    background: #00a6c6 !important;\r\n  }\r\n  .color-2{\r\n    color:#00a6c6;\r\n  }\r\n  .status-block{\r\n    margin-top: 30px;\r\n  }\r\n  .status-block .status-text{\r\n    top: 5px;\r\n    position: relative;\r\n    float: left;\r\n  }\r\n  .status-bar{padding: 18px 0}\r\n  .title-form .form-group {\r\n  \r\n  }\r\n  .report-action-btn span{\r\n    background: #00a6c6;\r\n    padding: 3px 0 0 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    height: 25px;\r\n    font-size: 12px;\r\n    width: 25px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .sn_dec {width: 80%}\r\n  .glyphicon-pencil{margin: 0 7px;}\r\n  .pagination>li>a, .pagination>li>span { border-radius: 50% !important;margin: 0 5px;}\r\n  .pagination{margin: 0px}\r\n  .btn-sm-rounded{    vertical-align: top;\r\n    margin-top: 6px;}\r\n    .modal-body {\r\n      position: relative;\r\n      padding: 28px 46px;\r\n  }\r\n  .plan-a{float: left;width: 100%;}\r\n  .clr_bg{background: #fff;}\r\n  table tr td:last-child{text-align: right;}\r\n  .btn-gray {\r\n    background-color: #999!important;\r\n}\r\n.planhead{float: left}\r\n.planhead1{float: right}\r\n.client-name {\r\n  \r\n    color: #d6104c;\r\n    font-weight: bold;       width: 135px;\r\n    float: right\r\n}\r\n.client-name span {\r\n    float: left;\r\n    font-size: 13px;\r\n    width: 100%;\r\n    font-weight: normal;\r\n    color: #949599;\r\n}\r\n.bluecomplete{color: #00a6c6}\r\n.tab-content{height: auto;\r\n }\r\n  .rdesc{padding-top: 0;margin-top: -2px}\r\n  .btn-circle {\r\n    width: 30px;\r\n    height: 30px;\r\n    text-align: center;\r\n    padding: 6px 0;\r\n    font-size: 12px;\r\n    line-height: 1.428571429;\r\n    border-radius: 15px;\r\n}\r\n\r\n.btn-primary {\r\n  border-color: #949599;\r\n  position: relative;\r\n  top: 42px;\r\n  left: -11px;    background-color: #fff;\r\n}\r\n.glyphicon {\r\n\r\n  color: #949599;\r\n}\r\n.scenario .tab-content {\r\n  height: auto;\r\n  overflow: hidden;}\r\n  .btn-primary{position: inherit}\r\n\r\n  #scenario-list-accordion .report-arrow {\r\n    cursor: pointer;\r\n    padding: 6px;\r\n    border: 2px solid #00a6c6;\r\n    border-radius: 50%;\r\n    color: #00a6c6;\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n\r\n.panel-title {\r\n  font-size: 16px;\r\n  color: inherit;\r\n  display: inline;\r\n  background: #0075bc !important;\r\n  padding: 4px 21px;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n  padding-left: 34px;\r\n}\r\n.panel-title > a:before {\r\n    float: left !important;\r\n    font-family: FontAwesome;\r\n    content:\"\\f068\";\r\n    padding-right: 5px;\r\n    color: #fff;\r\n    position: relative;\r\n    left: 30px;\r\n}\r\n.panel-title > a.collapsed:before {\r\n    float: left !important;\r\n    content:\"\\f067\";\r\n    color: #fff;\r\n    position: relative;\r\n    left: 30px;\r\n}\r\n.panel-title > a:hover, \r\n.panel-title > a:active, \r\n.panel-title > a:focus  {\r\n    text-decoration:none;\r\n}\r\n.panel-body {\r\n  padding: 15px 40px;\r\n}\r\n.left-block{float: left}\r\n.right-block{float: right}\r\n.panel{border:none;}\r\n.accord-block{float: left;width: 100%;    margin-bottom: 15px;}\r\n.accord-block:last-child{    margin-bottom: 0;}\r\n.panel-group {\r\n \r\n  background: #fff;\r\n}\r\n.rdesc{padding-top: 0;margin-top: -2px}\r\n.btn-circle {\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  padding: 6px 0;\r\n  font-size: 12px;\r\n  line-height: 1.428571429;\r\n  border-radius: 15px;\r\n}\r\n\r\n.bus-name .btn-primary {\r\nborder-color: #949599;\r\nposition: relative;\r\ntop: 42px;\r\nleft: -11px;    background-color: #fff;\r\n}\r\n.bg-white .glyphicon {\r\n\r\ncolor: #949599;\r\n}\r\n.client-name {\r\n  color: #d6104c;\r\n  font-weight: bold;\r\n  width: 135px;\r\n  float: right;\r\n}\r\n.client-name span {\r\n  float: left;\r\n  font-size: 13px;\r\n  width: 100%;\r\n  font-weight: normal;\r\n  color: #949599;\r\n}\r\n.btn-gray {\r\n  background-color: #999!important;\r\n}\r\n.edit1{top:7px;}\r\n.btn-marign{margin-bottom: 10px}\r\n#accordion_new b{    color: #00a6c6;}\r\n#accordion_new  .row{    margin-bottom: 7px;}\r\n\r\n.panel-body td th ,.panel-body tr td,.panel-body tr th {\r\n  border: 1px solid #ccc;\r\n  padding: 6px 0;\r\n  text-align: center !important;\r\n}\r\n.navbar-nav>li>a{\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  padding-left: 0px;\r\n  font-size: 13px;\r\n  margin-left: -7px;\r\n}\r\n.nav>li>a>img {\r\n  max-width: none;\r\n  width: 32px;\r\n  margin-right: 0px;\r\n  margin-bottom: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
